export default __webpack_public_path__ + "static/eventForm-42c8eac866ff8c5678009c84fb6fd450.jpg";